import Stack from '@mui/material/Stack';
import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form';
import { useTranslation } from 'react-i18next';

export function AudienceDetails({ name, description }: { name: string; description?: string | null }) {
  const { t } = useTranslation();

  return (
    <FormSection divider title={t('Audience Details')} rightColumnSize={RIGHT_COLUMN_WIDTH}>
      <Stack spacing={2}>
        <FieldDetails title={t('Name')} value={name} dataTest="audience-details-name" />
        {description && (
          <FieldDetails title={t('Description')} value={description} dataTest="audience-details-description" />
        )}
      </Stack>
    </FormSection>
  );
}
